/* PDP-10 (16.09.2026) · зазор до Style with и появление по первой прокрутке.
   Пара к amore-pdp-10.css. Старый bindStickyColumn в amore-pdp.js продолжает ставить
   inline top/margin-bottom этажам — CSS PDP-10 перебивает их !important. */
(function () {
  var MQ = '(min-width: 900px)';
  var STACK_TOP = 100;   // = top у .amore-pdp__buy-stack в amore-pdp-10.css
  var BOTTOM_GAP = 24;   // Toteme: низ фото Style with → низ окна 25
  var MIN_GAP = 40;      // низкое окно: не ближе 40 к ссылкам

  function init(root) {
    if (root.dataset.amorePdp10) return;
    root.dataset.amorePdp10 = '1';
    var stack = root.querySelector('[data-amore-pdp-buy-stack]');
    var styleWith = root.querySelector('[data-amore-style-with]');
    if (!stack || !styleWith) return;

    function recompute() {
      if (!window.matchMedia(MQ).matches) {
        stack.style.removeProperty('--amore-pdp10-sw-gap');
        return;
      }
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var swHeight = styleWith.getBoundingClientRect().height;
      var currentGap = parseFloat(window.getComputedStyle(styleWith).marginTop) || 0;
      var above = stack.getBoundingClientRect().height - swHeight - currentGap;
      var gap = Math.max(MIN_GAP, vh - BOTTOM_GAP - swHeight - (STACK_TOP + above));
      stack.style.setProperty('--amore-pdp10-sw-gap', Math.round(gap * 10) / 10 + 'px');
    }

    var timer = null;
    function request() {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () { timer = null; recompute(); }, 50);
    }

    function reveal() {
      if ((window.scrollY || window.pageYOffset) > 0) {
        styleWith.classList.add('is-revealed');
        window.removeEventListener('scroll', reveal);
      }
    }

    window.addEventListener('resize', request);
    window.addEventListener('scroll', reveal, { passive: true });
    root.addEventListener('change', request);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(request);
    if ('ResizeObserver' in window) new ResizeObserver(request).observe(stack);
    window.setTimeout(request, 900);
    recompute();
    reveal();
  }

  function run() {
    document.querySelectorAll('amore-product').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
